import React, { ReactNode } from 'react';

import { withComponent } from '@sms/plasma-ui';

import * as styled from './EmbeddedPage.styles';

export interface EmbeddedPageProps {
  children?: ReactNode;
}

function EmbeddedPage(props: EmbeddedPageProps) {
  const { children } = props;

  return (
    <>
      <styled.EmbeddedPage />
      {children}
    </>
  );
}

export default withComponent(EmbeddedPage);
